<template>
  <TsCard :id="'review-' + random_id"
          :data-testid="props.dataTestid"
          no-shadow
          append-class="md:px-4 px-2 md:py-4 py-2 bg-idle-white"
          body-class="py-0"
          footer-class="pt-0"
  >
    <template #content>
      <TsMedia appendClass="block lg:flex items-center">
        <TsRow is-multiline class="m-auto w-full">
          <TsColumn class="lg:is-9 p-0">
            <TsMediaStart>
              <TsMedia>
                <TsMediaStart appendClass="lg:border lg:bg-white lg:rounded-lg px-2 py-2.5 w-[140px] h-[140px]">
                  <slot name="left-section">
                    <TsImage v-if="props.imgSrc && props.imgSrc.url"
                             :src="props.imgSrc.url" class="m-auto"
                             :alt="props.imgSrc.alt" height="115px"
                             width="99px"
                             loading="lazy"/>
                  </slot>
                </TsMediaStart>
                <TsMediaContent appendClass="my-auto">
                  <slot name="right-section">
                    <slot name="title">
                      <TsTypography v-if="props.title" as="h3" appendClass="mb-0 ">
                        <div v-html="props.title"></div>
                      </TsTypography>
                    </slot>
                    <slot name="description">
                      <TsTypography v-if="props.description">
                        <div v-html="props.description"></div>
                      </TsTypography>
                    </slot>
                  </slot>
                </TsMediaContent>
              </TsMedia>
            </TsMediaStart>
          </TsColumn>
          <TsColumn class="pt-0 my-auto">
            <TsMediaEnd>
              <slot name="bottom-section">
                <TsRow isMultiline>
                  <TsColumn v-if="props.remindButtonLabel" class="lg:is-12 is-6 flex justify-end">
                    <TsButton
                        :data-testid="props.dataTestid+'remind-button'"
                        appendClass="whitespace-nowrap max-w-[246px]"
                        block
                        @click="emit('remind')"
                        outlined
                    >
                      {{ props.remindButtonLabel }}
                    </TsButton>
                  </TsColumn>
                  <TsColumn v-if="props.reviewButtonLabel" class="lg:is-12 is-6 flex justify-end">
                    <TsButton
                        :data-testid="props.dataTestid+'review-button'"
                        appendClass="whitespace-nowrap max-w-[246px]"
                        block
                        @click="emit('review')"
                    >
                      {{ props.reviewButtonLabel }}
                    </TsButton>
                  </TsColumn>
                </TsRow>
              </slot>
            </TsMediaEnd>
          </TsColumn>
        </TsRow>
      </TsMedia>
    </template>
  </TsCard>
</template>

<script setup lang="ts">
const {isMobile} = useDevice();
import {onMounted, ref} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);
const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);
const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);
const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);


type Props = {
  dataTestid?: string,
  imgSrc?: object,
  title?: string,
  description?: string,
  remindButtonLabel?: string,
  reviewButtonLabel?: string,


};
const emit = defineEmits(['remind', 'review'])
const props = withDefaults(defineProps<Props>(), {
  imgSrc: () => ({url: '/images/reviewBannerDrill.png', alt: 'productImage'}),
  title: 'Review Your Latest Product',
  description: 'Love your DeWalt drill? Share your experience with us and help others choose the best!',
  reviewButtonLabel: 'Review Item',
});
const buttonClass = "w-full"
const random_id = ref<string>("");

onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
